import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import { getLineItemQuantityAlreadyRejectedByMerchant } from "./get-line-item-quantity-already-rejected-by-merchant";
import { getLineItemQuantityAlreadyValidatedByMerchant } from "./get-line-item-quantity-already-validated-by-merchant";

type UseLineItemrejectedByMerchantMaxQuantityParams = {
  lineItem: ReturnRequestLineItemDto;
};

export function getLineItemRejectedByMerchantSelectableQuantity({
  lineItem,
}: UseLineItemrejectedByMerchantMaxQuantityParams) {
  const quantityValidatedByMerchant =
    getLineItemQuantityAlreadyValidatedByMerchant({ lineItem });
  const quantityRejectedByMerchant =
    getLineItemQuantityAlreadyRejectedByMerchant({ lineItem });
  return quantityRejectedByMerchant - quantityValidatedByMerchant;
}
